var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-filter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter",
    clipPath: "url(#clip-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16872",
    "data-name": "Group 16872",
    transform: "translate(10861.5 17544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29680",
    "data-name": "Rectangle 29680",
    width: 15,
    height: 2,
    rx: 1,
    transform: "translate(-10861 -17542)",
    fill: "#1f2939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29681",
    "data-name": "Rectangle 29681",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(-10859 -17537)",
    fill: "#1f2939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29682",
    "data-name": "Rectangle 29682",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(-10857 -17532)",
    fill: "#1f2939"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86563024de281c06421bf4af20f154b4.svg";
export { ForwardRef as ReactComponent };